import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import useAutoRefresh from "../lib/useAutoRefresh";
import { Grid3x3, Package } from "lucide-react";

export default function Shelves() {
  const [shelves, setShelves] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = React.useCallback(() => {
    setLoading(true);
    api
      .get("/shelves")
      .then(({ data }) => setShelves(data))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  useAutoRefresh(load);

  return (
    <div className="space-y-4">
      <div className="hard border border-[color:var(--border)] bg-[color:var(--surface)] p-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Grid3x3 size={18} />
          <h3 className="font-bold">Sehpa Konumları</h3>
        </div>
        <div className="ticker text-[color:var(--text-3)]">
          {loading ? "Yükleniyor…" : `${shelves.length} sehpa`}
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
        {shelves.map((s) => (
          <Link
            key={s.sehpa}
            to={`/stok?sehpa=${encodeURIComponent(s.sehpa)}`}
            data-testid="shelf-card"
            className="hard border border-[color:var(--border)] bg-[color:var(--surface)] p-4 hover:border-[color:var(--primary)] transition-colors group"
          >
            <div className="flex items-start justify-between">
              <div className="font-mono text-xl font-black tracking-tight">
                {s.sehpa}
              </div>
              <Package
                size={16}
                className="text-[color:var(--text-3)] group-hover:text-[color:var(--primary)] transition-colors"
              />
            </div>
            <div className="mt-4 text-xs text-[color:var(--text-2)] space-y-1">
              <div>
                <span className="ticker">Ürün</span>{" "}
                <span className="font-mono font-bold text-[color:var(--text)]">
                  {s.product_count}
                </span>
              </div>
              <div>
                <span className="ticker">Adet</span>{" "}
                <span className="font-mono font-bold text-[color:var(--text)]">
                  {s.total_adet}
                </span>
              </div>
            </div>
          </Link>
        ))}
        {!loading && shelves.length === 0 && (
          <div className="col-span-full py-16 text-center text-[color:var(--text-3)]">
            Henüz sehpa yok.
          </div>
        )}
      </div>
    </div>
  );
}
